// Pause / reset les <video> et <iframe> à la fermeture d'une modal Bootstrap
// qui contient un media. Sans ça, YouTube/Vimeo continuent à jouer en arrière-plan.

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.modal').forEach(modal => {
        modal.addEventListener('hidden.bs.modal', () => {
            modal.querySelectorAll('video').forEach(v => {
                try { v.pause(); v.currentTime = 0; } catch (e) {}
            });
            modal.querySelectorAll('iframe').forEach(iframe => {
                const src = iframe.getAttribute('src');
                if (src) {
                    // Recharge l'iframe pour stopper la lecture (YouTube/Vimeo)
                    iframe.setAttribute('src', src);
                }
            });
        });
    });
});
